// extracted by mini-css-extract-plugin
export var defaultWrapper = "_lg-3";
export var downloadButton = "_lg-4";
export var fileContainer = "_lg-9 _lg-7";
export var fileContainerBase = "_lg-7";
export var fileContainerFixedHeight = "_lg-8 _lg-7";
export var fileInfo = "_lg-5";
export var fileInfoWidthRestricted = "_lg-6";
export var fileType = "_lg-1";
export var fileTypeName = "_lg-2";
export var image = "_lg-0";
export var link = "_lg-b";
export var overflowEllipsis = "_lg-a";